import React, { useState } from "react";
import hand from "./Images/hand.png";
import "./css/Thirdpage.css";

import {
  HiOutlineArrowNarrowRight,
  HiOutlineArrowNarrowLeft,
} from "react-icons/hi";
function ThirdPage() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide === 1 ? 0 : 1));
  };

  const prevSlide = () => {
    setCurrentSlide((prevSlide) => (prevSlide === 0 ? 1 : 0));
  };
  return (
    <div className="third-page">
      <div className="blue-container">
        <div className="hand">
          <img src={hand} alt="hand" />
        </div>

        <div className="box-section">
          <div className="slider">
            <div
              className="boxes"
              style={{ transform: `translateX(-${currentSlide * 120}%)` }}
            >
              <div className="rectangle1">
                <div className="text-r">Business growth & support</div>
                <div className="info1">
                  BGS URBAN NIDHI LIMITED is a leading financial institution
                  dedicated to providing personalized banking solutions to
                  individuals, businesses, and communities. With a focus on
                  innovation, integrity, and customer service excellence, we
                  strive to empower our customers to achieve their financial
                  goals.
                </div>
              </div>

              <div className="rectangle2">
                <div className="info2">
                  Discover the difference of banking with BGS, where our values
                  of integrity, respect, and excellence drive everything we do
                  <br />
                  Discover the difference of banking with BGS, where our values
                  of integrity, respect, and excellence drive everything we do
                  <br />
                  Discover the difference of banking with BGS, where our values
                  of integrity, respect, and excellence drive everything we do
                </div>
              </div>
            </div>
          </div>
          <div className="buttons md:hidden">
            <button onClick={prevSlide}>
              <HiOutlineArrowNarrowLeft />
            </button>
            <button onClick={nextSlide}>
              <HiOutlineArrowNarrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
export default ThirdPage;
